import { forwardRef } from 'react';

import { SvgStyled } from '@sternum/web/icons/icons.styles';
import { IconProps } from '@sternum/web/icons/icons.types';

export const XIcon = forwardRef<SVGSVGElement, IconProps>(function XIcon(
  { color = '', height = 12, width = 12, hasCursorPointer = false, ...props },
  ref,
) {
  return (
    <SvgStyled
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-has-cursor-pointer={hasCursorPointer}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.31664 3.31664C3.44366 3.18961 3.64961 3.18961 3.77664 3.31664L6 5.53999L8.22336 3.31664C8.35039 3.18961 8.55634 3.18961 8.68336 3.31664C8.81039 3.44366 8.81039 3.64961 8.68336 3.77664L6.46001 6L8.68336 8.22336C8.81039 8.35039 8.81039 8.55634 8.68336 8.68336C8.55634 8.81039 8.35039 8.81039 8.22336 8.68336L6 6.46001L3.77664 8.68336C3.64961 8.81039 3.44366 8.81039 3.31664 8.68336C3.18961 8.55634 3.18961 8.35039 3.31664 8.22336L5.53999 6L3.31664 3.77664C3.18961 3.64961 3.18961 3.44366 3.31664 3.31664Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.16011 3.93317C2.94663 3.7197 2.94663 3.37358 3.16011 3.16011C3.37358 2.94663 3.7197 2.94663 3.93317 3.16011L6 5.22694L8.06683 3.16011C8.2803 2.94663 8.62642 2.94663 8.83989 3.16011C9.05337 3.37358 9.05337 3.7197 8.83989 3.93317L6.77306 6L8.83989 8.06683C9.05337 8.2803 9.05337 8.62642 8.83989 8.83989C8.62642 9.05337 8.2803 9.05337 8.06683 8.83989L6 6.77306L3.93317 8.83989C3.7197 9.05337 3.37358 9.05337 3.16011 8.83989C2.94663 8.62642 2.94663 8.2803 3.16011 8.06683L5.22694 6L3.16011 3.93317ZM3.47317 3.47317C3.43259 3.51374 3.43259 3.57953 3.47317 3.62011L5.69652 5.84347C5.78297 5.92992 5.78297 6.07008 5.69652 6.15653L3.47317 8.37989C3.43259 8.42047 3.43259 8.48626 3.47317 8.52683C3.51374 8.56741 3.57953 8.56741 3.62011 8.52683L5.84347 6.30348C5.92992 6.21703 6.07008 6.21703 6.15653 6.30348L8.37989 8.52683C8.42047 8.56741 8.48626 8.56741 8.52683 8.52683C8.56741 8.48626 8.56741 8.42047 8.52683 8.37989L6.30348 6.15653C6.21703 6.07008 6.21703 5.92992 6.30348 5.84347L8.52683 3.62011C8.56741 3.57953 8.56741 3.51374 8.52683 3.47317C8.48626 3.43259 8.42047 3.43259 8.37989 3.47317L6.15653 5.69652C6.07008 5.78297 5.92992 5.78297 5.84347 5.69652L3.62011 3.47317C3.57953 3.43259 3.51374 3.43259 3.47317 3.47317Z"
        fill={color || 'currentColor'}
      />
    </SvgStyled>
  );
});
